export const GET_THREADPATTERNS_STATED = "GET_THREADPATTERNS_STATED";
export const GET_THREADPATTERNS = "GET_THREADPATTERNS";
export const GET_THREADPATTERNS_ENDED = "GET_THREADPATTERNS_ENDED";
export const ADD_THREADPATTERN_STATED = "ADD_THREADPATTERN_STARTED";
export const ADD_THREADPATTERN = "ADD_THREADPATTERN";
export const ADD_THREADPATTERN_ENDED = "ADD_THREADPATTERN_ENDED";
export const EDIT_THREADPATTERN_STATED = "EDIT_THREADPATTERN_STATED";
export const EDIT_THREADPATTERN = "EDIT_THREADPATTERN";
export const EDIT_THREADPATTERN_ENDED = "EDIT_THREADPATTERN_ENDED";
export const GET_THREADPATTERN = "GET_THREADPATTERN";
export const GET_THREADPATTERN_STATED = "GET_THREADPATTERN_STATED";
export const GET_THREADPATTERN_ENDED = "GET_THREADPATTERN_ENDED";
export const RESET_THREADPATTERN = "RESET_THREADPATTERN";
export const ERROR_THREADPATTERN = "ERROR_THREADPATTERN";
export const GET_ALL_THREADPATTERNS_STATED = "GET_ALL_THREADPATTERNS_STATED";
export const GET_ALL_THREADPATTERNS = "GET_ALL_THREADPATTERNS";
export const GET_ALL_THREADPATTERNS_ENDED = "GET_ALL_THREADPATTERNS_ENDED";
